/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'accounts';
const componentName = 'individual-tenant-setting-modal-service';
const prefix = `${moduleName}.${componentName}`;

export const individualTenantsLabel = `${prefix}.individualTenantsLabel`;

export const ENGLISH = {
    [individualTenantsLabel]: 'Individual Tenant',
};
